var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6541 8.86021L16.0761 4.37246C15.5974 3.5392 14.3967 3.53522 13.9125 4.36528L11.192 9.02887C10.8317 9.64657 10.2241 10.0804 9.52289 10.2206L5.80574 10.9641C4.84302 11.1566 4.46788 12.333 5.1414 13.0473L7.82994 15.8988C8.40484 16.5085 8.636 17.3658 8.44557 18.1819L7.22865 23.3973C6.9785 24.4694 8.13612 25.3179 9.08321 24.7567L13.726 22.0054C14.5118 21.5397 15.4891 21.5397 16.275 22.0054L20.9178 24.7567C21.8648 25.3179 23.0225 24.4694 22.7723 23.3973L21.5447 18.1362C21.3602 17.3454 21.5713 16.5142 22.1108 15.9072L24.8027 12.8789C25.444 12.1574 25.0602 11.0121 24.1136 10.8227L20.3316 10.0664C19.6247 9.92497 19.0133 9.48531 18.6541 8.86021Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9c678f5578dc781f4fb1e26b8e768757.svg";
export { ForwardRef as ReactComponent };